import { useContext, useEffect, useState } from "react";
import "./Ecommerce.scss";
import { EcommerceSearchSubHeader } from "../../order_entry/EcommerceSearchSubHeader/EcommerceSearchSubHeader";
import INotification from "../../../models/INotification";
import ICategory from "../../../models/ICategory";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOnGetCategoriesDTO from "../../../models/DTO/IOnGetCategoriesDTO";
import IOnGetCategoryCatalogItemsDTO from "../../../models/DTO/IOnGetCategoryCatalogItemsDTO";
import IOnTypeaheadCatalogItemDTO from "../../../models/DTO/IOnTypeaheadCatalogItemDTO";
import IGetCategoriesDTO from "../../../models/DTO/IGetCategoriesDTO";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import VendorContext from "../../../contexts/VendorContext";
import ITypeaheadCatalogItemDTO from "../../../models/DTO/ITypeaheadCatalogItemDTO";
import IGetCategoryCatalogItemsDTO from "../../../models/DTO/IGetCategoryCatalogItemsDTO";
import ICatalog_Item from "../../../models/ICatalog_Item";
import EcommerceListView from "../../order_entry/EcommerceListView/EcommerceListView";
import PaginationBar from "../../shared/PaginationBar/PaginationBar";
import IOrder from "../../../models/IOrder";
import styled from "styled-components";
import IDraftOrderItem from "../../../models/IDraftOrderItem";
import IAddItemToCartDTO from "../../../models/DTO/IAddItemToCartDTO";
import IOnAddItemToCartDTO from "../../../models/DTO/IOnAddItemToCartDTO";
import { EcommerceCart } from "../EcommerceCart/EcommerceCart";
import { EcommerceRightSideHeader } from "../EcommerceRightSideHeader/EcommerceRightSideHeader";
import { useMatch, useNavigate, useSearchParams } from "react-router-dom";
import { EcommerceCategorySidebar } from "../../order_entry/EcommerceCategorySidebar/EcommerceCategorySidebar";
import { LoginMessage } from "../../dashboard/LoginMessage/LoginMessage";
import { EcommerceItemDetailPage } from "../EcommerceItemDetailPage/EcommerceItemDetailPage";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import { ProcessOrderEntryItemFn } from "../../../models/OrderEntryTypes";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import { SocketContext } from "../../../contexts/SocketContext";
import UiContext from "../../../contexts/UiContext";
import CategoryContext from "../../../contexts/CategoryContext";
import { EcommerceHomeCategoryListView } from "../EcommerceHomeCategoryListView/EcommerceHomeCategoryListView";
import { useEcommerceLogic } from "@hooks/ecommerce/useEcommerceLogic";
import { useCart } from "@contexts/CartContext";
import ICart_Item from "@models/ICart_Item";
import { EcommerceListViewSkeleton } from "../EcommerceListViewSkeleton/EcommerceListViewSkeleton";
import { EcommerceNoResults } from "../EcommerceNoResults/EcommerceNoResults";
import { MobileCartNotification } from "../MobileCartNotification/MobileCartNotification";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import { OwP } from "@components/shared/OwP/OwP";
import OwButton from "@components/shared/OwButton/OwButton";

type Props = {};

export const Ecommerce: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const vendorModel = useContext(VendorContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);
    const categoryContext = useContext(CategoryContext);
    const { cart, refreshCart } = useCart();

    const match = useMatch("/ecomm/:itemName");

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const categoryGuidFromUrl = searchParams.get("category");
    const searchTermFromUrl = searchParams.get("search");

    const { showHomeCategories } = useEcommerceLogic();

    const hasValidAccountSetup = !!(vendorModel.Catalog && vendorModel.Price_Group);

    const [homeCategories, setHomeCategories] = useState<ICategory[]>([]);
    const [categories, setCategories] = useState<ICategory[]>([]);
    const [enteredSearchTerm, setEnteredSearchTerm] = useState<string>(searchTermFromUrl || "");
    const [limit, setLimit] = useState<number>(20);
    const [offset, setOffset] = useState<number>(0);
    const [rootCategories, setRootCategories] = useState<ICategory[] | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isCommonItems, setIsCommonItems] = useState(true);
    const [searchItems, setSearchItems] = useState<ICatalog_Item[]>([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [performedInitialSearch, setPerformInitialSearch] = useState(false);
    const [selectedCategoryGuid, setSelectedCategoryGuid] = useState<string | undefined>();
    const [cartOpen, setCartOpen] = useState(false);
    const [retrievedCategories, setRetrievedCategories] = useState(false);
    const [selectedCategoryDetail, setSelectedCategoryDetail] = useState<{ name?: string; guid?: string }>({
        guid: categoryGuidFromUrl || undefined,
    });
    const [selectedItem, setSelectedItem] = useState<ICatalog_Item | null>(null);
    const [isCategoryLoading, setIsCategoryLoading] = useState(false);
    const [clearSearchTerm, setClearSearchTerm] = useState(0);
    const [showMobileCartNotification, setShowMobileCartNotification] = useState(false);
    const [mobileCartItem, setMobileCartItem] = useState<ICart_Item | null>(null);

    useEffect(() => {
        if (!hasValidAccountSetup) {
            uiContext.setModalCloseOnOverlayClick(false);
            uiContext.setModalCloseOnEsc(false);
            uiContext.setModalComponent(
                <div className="p-4 d-flex flex-column align-items-center text-center" style={{ maxWidth: "40vw" }}>
                    <i className="fas fa-exclamation-triangle text-warning mb-3" style={{ fontSize: "3rem" }} />
                    <OwTitle className="mb-3" title="account_setup_required" tag="h4" />
                    <OwP className="mb-4 text-start" content="account_setup_required_message" />
                    <OwP className="mb-4 text-start" content="account_setup_required_message_2" />
                    <OwButton
                        title="i_understand"
                        className="btn btn-primary"
                        fn={() => {
                            uiContext.showModal(false);
                            uiContext.setModalComponent(null);
                            uiContext.resetModalClassesAndStyles();
                        }}
                    />
                </div>
            );
            uiContext.showModal(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasValidAccountSetup]);

    useEffect(() => {
        if (categoryGuidFromUrl !== selectedCategoryDetail.guid) {
            setSelectedCategoryDetail({ guid: categoryGuidFromUrl || undefined });
        }
    }, [categoryGuidFromUrl]);

    useEffect(() => {
        if (!hasValidAccountSetup) {
            return;
        }

        if (socket) {
            for (const _socket of sockets) {
                socket.on(_socket.endpoint, _socket.fn);
            }

            getCategories();

            if (supplierModel.has_home_categories && !categoryGuidFromUrl) {
                getHomeCategories();
            }

            document.title = "Orderwerks >> Home";

            // getTypeaheadCatalogItem(true);
            setupRightSideHeaderComponent();
            refreshCart();
        }

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }

            uiContext.setSubHeaderComponent(null);
        };
    }, [vendorModel.guid]);

    // Update cart item count when cart changes
    useEffect(() => {
        if (cart?.Cart_Items) {
            let count = 0;
            for (const item of cart.Cart_Items) {
                if (!item.parent_cart_item_id) {
                    count++;
                }
            }
            uiContext.setCartItemCount(count);
        }
    }, [cart]);

    const onGetCategories = (data: IOnGetCategoriesDTO) => {
        if (data.onlyRootCategories) {
            setRootCategories(data.categories);
        }

        if (data.isHomeCategories) {
            setHomeCategories(data.categories);
        } else {
            setCategories(data.categories);
        }

        if (!data.isHomeCategories) {
            setupSearchSubHeader();
            setRetrievedCategories(true);
        }
    };

    const onGetProductsInCategory = (data: IOnGetCategoryCatalogItemsDTO) => {
        setSearchItems(data.catalogItems);
        setIsCategoryLoading(false);

        if (data.totalItems) {
            setTotalRecords(data.totalItems);
        }

        // move the user to the top of the page
        document.getElementById("mainView")?.scroll({ top: 0, left: 0, behavior: "smooth" });
    };

    const onGetTypeaheadCatalogItem = (data: IOnTypeaheadCatalogItemDTO) => {
        setSearchItems(data.catalog_items);
        setPerformInitialSearch(true);
        setTotalRecords(data.totalCatalogItems);
        setIsLoading(false);

        document.getElementById("mainView")?.scroll({ top: 0, left: 0, behavior: "auto" });
        uiContext.setActivityIndicator(isLoading);
    };

    const onAddToCart = (data: IOnAddItemToCartDTO) => {
        refreshCart();

        const isMobile = window.innerWidth < 768; // Bootstrap md breakpoint

        if (isMobile) {
            // On mobile, show bottom sheet notification instead of sidebar
            setMobileCartItem(data.cartItem);
            setShowMobileCartNotification(true);
        } else {
            // On desktop, open sidebar as before
            toggleCartSidebar();
        }

        const notification = {
            message: "item_added_to_cart",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        } as INotification;

        uiContext.notifyFn(null, notification);
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.CatalogItemOnTypeaheadCatalogItem, fn: onGetTypeaheadCatalogItem },
        { endpoint: EndpointsEnum.CategoriesOnGetCategoryCatalogItems, fn: onGetProductsInCategory },
        { endpoint: EndpointsEnum.CategoriesOnGetCategories, fn: onGetCategories },
        { endpoint: EndpointsEnum.CartOnAddItem, fn: onAddToCart },
    ];

    useEffect(() => {
        if (match?.params.itemName) {
            console.log("isItemDetail: ", selectedItem);
        }
    }, [match?.params.itemName]);

    useEffect(() => {
        setupSearchSubHeader();
    }, [categories]);

    useEffect(() => {
        if (retrievedCategories) {
            setupSearchSubHeader();
        }
    }, [cartOpen]);

    useEffect(() => {
        if (retrievedCategories && clearSearchTerm) {
            setupSearchSubHeader();
        }
    }, [clearSearchTerm]);

    /**
     * Anytime the offset or limit are changed, will be the main process for getting the next page
     * This also helps us with preventing double api calls.
     *
     * NOTE: This gets called when the page loads
     */
    useEffect(() => {
        if (!selectedCategoryDetail.guid) {
            getTypeaheadCatalogItem(isCommonItems, selectedCategoryGuid, enteredSearchTerm);
        } else {
            getProductsInCategory();
        }
    }, [offset, limit]);

    useEffect(() => {
        // Only load category products if we're browsing a category (not searching within one)
        if (selectedCategoryDetail.guid && !searchTermFromUrl) {
            setSearchItems([]);
            setIsCategoryLoading(true);
            getProductsInHomeCategory();
        }
    }, [selectedCategoryDetail, searchTermFromUrl]);

    useEffect(() => {
        // Initialize categoryContext from URL param when root categories are loaded
        if (categoryGuidFromUrl && rootCategories?.length) {
            const categoryFromUrl = rootCategories.find((cat) => cat.guid === categoryGuidFromUrl);
            if (categoryFromUrl && categoryContext.category?.guid !== categoryGuidFromUrl) {
                categoryContext.setFn(categoryFromUrl);
            }
        }
    }, [categoryGuidFromUrl, rootCategories]);

    // Handle initial search from URL params - runs once when categories are loaded
    useEffect(() => {
        if (searchTermFromUrl && retrievedCategories && !performedInitialSearch) {
            setIsCommonItems(false);
            getTypeaheadCatalogItem(false, categoryGuidFromUrl || undefined, searchTermFromUrl);
        }
    }, [searchTermFromUrl, retrievedCategories, performedInitialSearch, categoryGuidFromUrl]);

    const toggleCategorySidebar = () => {
        uiContext.setSidebarComponent(null);
        uiContext.toggleSidebar(false);
    };

    const getProductsInCategory = () => {
        if (selectedCategoryDetail) {
            const payload: IGetCategoryCatalogItemsDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                vendorGuid: vendorModel.guid,
                categoryGuid: selectedCategoryDetail.guid!,
                catalogGuid: vendorModel.Catalog!.guid,
                limit,
                offset,
                includeTotalItems: true,
            };

            socket.emit(EndpointsEnum.CategoriesGetCategoryCatalogItems, payload);
        }
    };

    const getProductsInHomeCategory = () => {
        if (selectedCategoryDetail) {
            const payload: IGetCategoryCatalogItemsDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                vendorGuid: vendorModel.guid,
                categoryGuid: selectedCategoryDetail.guid!,
                catalogGuid: vendorModel.Catalog!.guid,
                limit: 25,
                offset: 0,
                includeTotalItems: true,
            };

            socket.emit(EndpointsEnum.CategoriesGetCategoryCatalogItems, payload);
        }
    };

    const viewCategory = (category: ICategory) => {
        const currentOffsetZero = offset === 0;

        toggleCategorySidebar();

        setSearchItems([]);
        setIsCategoryLoading(true);
        setIsCommonItems(false);

        setSelectedCategoryGuid(category.guid);

        setEnteredSearchTerm("");

        setOffset(0);

        if (currentOffsetZero) {
            // performSearch("", category.guid);
            navigate(`/ecomm?category=${category.guid}`);
        }

        // move the user to the top of the page
        window.scrollTo(0, 0);
    };

    const toggleCatalogSidebar = () => {
        if (rootCategories) {
            const component = (
                <EcommerceCategorySidebar
                    rootCategories={rootCategories}
                    toggleSidebar={toggleCategorySidebar}
                    viewCategory={viewCategory}
                    hasNoOrder={true}
                />
            );

            uiContext.setSidebarComponent(component);
            uiContext.toggleSidebar(true, { pullRight: false });
        }
    };

    const viewCartMobile = () => {
        proceedToCheckout();
    };

    const toggleCartSidebar = () => {
        setCartOpen(true);
        const cartSidebarComponent = <EcommerceCart socket={socket} />;

        uiContext.setRightSideComponent(cartSidebarComponent);
        uiContext.toggleRightSide(true);
    };

    const cancelSidebar = () => {
        uiContext.setRightSideComponent(null);
        uiContext.toggleRightSide(false);
        setCartOpen(false);
    };

    const deleteCartItem = () => {};

    const updateCartItem = () => {};

    const toggleCheckoutView = () => {};

    const shouldHidePricingFn = (): boolean => {
        return true;
    };

    const performSearch = (searchTerm: string, _selectedCategoryGuid?: string | undefined) => {
        getTypeaheadCatalogItem(false, _selectedCategoryGuid, searchTerm);

        setEnteredSearchTerm(searchTerm);
        setSelectedCategoryGuid(_selectedCategoryGuid);
        setOffset(0);
        setIsCommonItems(false);

        let search = `?search=${searchTerm}`;

        if (_selectedCategoryGuid) {
            if (searchTerm.length) {
                search += `&`;
            } else {
                search = `?`;
            }

            search += `category=${_selectedCategoryGuid}`;
        }

        // move the user to the top of the page
        window.scrollTo(0, 0);

        navigate({
            pathname: `/ecomm/`,
            search,
        });
    };

    const getCommonItems = () => {
        // Reset all category/search state and load common items
        setSelectedCategoryDetail({});
        setSelectedCategoryGuid(undefined);
        setEnteredSearchTerm("");
        setIsCommonItems(true);
        setOffset(0);
        categoryContext.setFn(undefined);
        getTypeaheadCatalogItem(true, undefined, "");

        // Load home categories if supplier has them
        if (supplierModel.has_home_categories) {
            getHomeCategories();
        }
    };

    const getHomeCategories = () => {
        if (vendorModel.Catalog) {
            const payload: IGetCategoriesDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                catalogGuid: vendorModel.Catalog.guid,
                onlyRootCategories: false,
                isHomeCategories: true,
            };

            if (!userModel.isSupplierUser) {
                payload.vendorGuid = vendorModel.guid;
            }

            socket.emit(EndpointsEnum.CategoriesGetCategories, payload);
        }
    };

    const getCategories = () => {
        if (vendorModel.Catalog) {
            const payload: IGetCategoriesDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                onlyRootCategories: true,
                catalogGuid: vendorModel.Catalog.guid,
            };

            if (!userModel.isSupplierUser) {
                payload.vendorGuid = vendorModel.guid;
            }

            socket.emit(EndpointsEnum.CategoriesGetCategories, payload);
        }
    };

    const proceedToCheckout = () => {
        uiContext.setRightSideComponent(null);
        uiContext.setRightSideHeaderComponent(null);
        uiContext.toggleRightSide(false);
        navigate("/ecomm/checkout");
    };

    const setupRightSideHeaderComponent = () => {
        const headerComponent = <EcommerceRightSideHeader proceedToCheckout={proceedToCheckout} />;

        uiContext.setRightSideHeaderComponent(headerComponent);
    };

    const setupSearchSubHeader = () => {
        if (categories) {
            const subHeaderComponent = (
                <EcommerceSearchSubHeader
                    lookupLeft={"0"}
                    lookupWidth={"100%"}
                    toggleCatalogSidebar={toggleCatalogSidebar}
                    toggleCartSidebar={toggleCartSidebar}
                    cartOpen={cartOpen}
                    closeCartSidebar={cancelSidebar}
                    isReadOnly={false}
                    performSearch={performSearch}
                    isCheckoutView={false}
                    getCommonItems={getCommonItems}
                    viewCart={viewCartMobile}
                    categories={categories}
                    mainUrl={"/ecomm"}
                    clearSearchTerm={clearSearchTerm}
                    initialSearchTerm={searchTermFromUrl || ""}
                />
            );

            uiContext.setSubHeaderComponent(subHeaderComponent);
        }
    };

    const getTypeaheadCatalogItem = (isCommonsItems?: boolean, categoryGuid?: string, searchTerm?: string) => {
        if (vendorModel.Catalog) {
            const payload: ITypeaheadCatalogItemDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                catalogGuid: vendorModel.Catalog.guid,
                name: searchTerm || enteredSearchTerm,
                limit,
                offset,
                onlyActive: true,
                includeTotal: true,
                includeKitItems: true,
                priceGroupGuid: vendorModel.Price_Group?.guid,
                options: {
                    searchName: true,
                    searchSku: true,
                    searchDescription: true,
                    searchUpc: true,
                },
            };

            if (categoryGuid && rootCategories) {
                const categoryModel = rootCategories.find((cat) => cat.guid === categoryGuid);

                if (categoryModel) {
                    payload.categoryId = categoryModel.id;
                }
            }

            if (!userModel.isSupplierUser) {
                payload.vendorGuid = vendorModel.guid;
            }

            if (isCommonsItems) {
                payload.onlyCommonItems = true;
                payload.includeStandardIfNoCommonItems = true;
            }

            socket.emit(EndpointsEnum.CatalogItemTypeaheadCatalogItem, payload);

            setIsLoading(true);
            uiContext.setActivityIndicator(isLoading);
        }
    };

    const addToCart: ProcessOrderEntryItemFn = (item, options) => {
        if (cart?.Cart_Items) {
            for (const cartItem of cart.Cart_Items) {
                if (cartItem.catalog_item_id === item.id) {
                    const notification: INotification = {
                        message: "item_already_in_cart",
                        position: NotificationPositionEnum.bc,
                        level: NotificationLevelEnum.warning,
                    };

                    uiContext.notifyFn(null, notification);

                    return;
                }
            }
        }

        const _item = item as IDraftOrderItem;

        const payload: IAddItemToCartDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            vendorGuid: vendorModel.guid,
            qty: _item.qty,
            catalogItemGuid: item.guid,
        };

        if (options?.uomSet) {
            payload.uomSetId = options.uomSet.id;
        }

        if (options?.discount) {
            payload.discountId = options.discount.id;
        }

        if (options?.kitBuilderOptions) {
            payload.kitBuilderData = options.kitBuilderOptions;
        }

        if (options?.itemOptions) {
            payload.itemOptionValues = options.itemOptions.map((itemOption) => {
                return {
                    item_option_id: itemOption.item_option_id!,
                    value: itemOption.value,
                };
            });
        }

        socket.emit(EndpointsEnum.CartAddItem, payload);
    };

    const openDetailView = (item: ICatalog_Item) => {
        navigate(`/ecomm/item/${item.name}/${item.guid}`);
        setSelectedItem(item);
    };

    const onPaginationChanged = (selectedOffset: number, selectedLimit: number) => {
        setOffset(selectedOffset);
        setLimit(selectedLimit);

        // move the user to the top of the page
        document.getElementById("mainView")?.scroll({ top: 0, left: 0, behavior: "smooth" });
    };

    if (!hasValidAccountSetup) {
        return (
            <EcommerceContainer className={"Ecommerce container-fluid container-md mt-4"}>
                <AccountSetupMessage className="d-flex flex-column align-items-center text-center py-5">
                    <div className="d-flex flex-column align-items-center text-center" style={{ maxWidth: "40vw" }}>
                        <i className="fas fa-exclamation-triangle text-warning mb-3" style={{ fontSize: "3rem" }} />
                        <OwTitle className="mb-3" title="account_setup_required" tag="h4" />
                        <OwP className="mb-4 text-start" content="account_setup_required_message" />
                        <OwP className="mb-4 text-start" content="account_setup_required_message_2" />
                    </div>
                </AccountSetupMessage>
            </EcommerceContainer>
        );
    }

    return (
        <EcommerceContainer className={"Ecommerce container-fluid container-md mt-4"}>
            {match?.params?.itemName && selectedItem ? (
                <EcommerceItemDetailPage item={selectedItem} priceGroupName={vendorModel.Price_Group?.value || ""} socket={socket} />
            ) : (
                <>
                    {supplierModel.login_message_detail?.title?.length ? (
                        <div className={"mb-4"}>
                            <LoginMessage showPreviewBox={false} loginMessageDetail={supplierModel.login_message_detail} />
                        </div>
                    ) : null}

                    <ItemView className={"ecomm-grid mb-5"}>
                        {offset === 0 &&
                            showHomeCategories &&
                            homeCategories.map((homeCategory) => {
                                return <EcommerceHomeCategoryListView category={homeCategory} key={homeCategory.guid} />;
                            })}
                    </ItemView>
                    <ItemView className={"ecomm-grid"}>
                        {isCategoryLoading
                            ? Array.from({ length: 10 }).map((_, i) => <EcommerceListViewSkeleton key={`skeleton-${i}`} />)
                            : searchItems.map((item) => {
                                  return (
                                      <EcommerceListView
                                          key={item.guid}
                                          catalogItem={item}
                                          priceGroupName={vendorModel.Price_Group?.value || ""}
                                          addToCart={addToCart}
                                          openDetailView={openDetailView}
                                          isReadOnly={false}
                                          order={
                                              {
                                                  Price_Group: vendorModel.Price_Group,
                                              } as IOrder
                                          }
                                          socket={socket}
                                          isCategoryView={!!selectedCategoryGuid}
                                      />
                                  );
                              })}

                        {!isCategoryLoading && !searchItems.length && (performedInitialSearch || selectedCategoryDetail.guid) ? (
                            <EcommerceNoResults
                                searchTerm={enteredSearchTerm}
                                onClearFilters={() => {
                                    setEnteredSearchTerm("");
                                    setOffset(0);
                                    setClearSearchTerm((prev) => prev + 1);
                                    if (selectedCategoryDetail.guid) {
                                        // Stay on category, reload category products and update URL
                                        getProductsInCategory();
                                        navigate(`/ecomm?category=${selectedCategoryDetail.guid}`);
                                    } else {
                                        // No category selected, load common items and clear URL
                                        setSelectedCategoryGuid(undefined);
                                        setIsCommonItems(true);
                                        getTypeaheadCatalogItem(true, undefined, "");
                                        navigate("/ecomm/");
                                    }
                                }}
                                onBrowseAll={() => {
                                    setEnteredSearchTerm("");
                                    setSelectedCategoryGuid(undefined);
                                    setSelectedCategoryDetail({});
                                    setIsCommonItems(true);
                                    setOffset(0);
                                    categoryContext.setFn(undefined);
                                    getTypeaheadCatalogItem(true, undefined, "");
                                    navigate("/ecomm/");
                                }}
                            />
                        ) : null}
                    </ItemView>
                    {searchItems.length && totalRecords ? (
                        <PaginationContainer className={"d-md-flex justify-content-md-center"}>
                            <PaginationBar
                                offset={offset}
                                limit={limit}
                                totalRecords={totalRecords}
                                onPaginationChanged={onPaginationChanged}
                                hideLimit={true}
                            />
                        </PaginationContainer>
                    ) : null}
                </>
            )}

            <MobileCartNotification
                show={showMobileCartNotification}
                cartItem={mobileCartItem}
                onClose={() => setShowMobileCartNotification(false)}
                onViewCart={() => {
                    setShowMobileCartNotification(false);
                    proceedToCheckout();
                }}
            />
        </EcommerceContainer>
    );
};

const EcommerceContainer = styled.div`
    margin-bottom: 5rem;
`;

const ItemView = styled.div`
    //display: flex;
    //width: 100%;
    //margin-bottom: 5rem;
    //flex-wrap: wrap;
`;

const PaginationContainer = styled.div`
    //width: 100%;
    //justify-content: center;
`;

const AccountSetupMessage = styled.div`
    min-height: 50vh;
    justify-content: center;
`;
